import banner from '../../../assets/images/svg/new-plan/banner/banner.png';
import bannerTaxi from '../../../assets/images/svg/autoefectivo-taxi/banner/banner-taxi.png';
import bannerLaunch from '../../../assets/images/svg/autoefectivo-taxi/banner/banner-launch.png';
import MirrorPageEnums from '../enums/mirror-page';

export const imageBanner = (pathname: string) => {
  const images: { [key: string]: string } = {
    [MirrorPageEnums.TAXI]: bannerTaxi,
    [MirrorPageEnums.LAUNCH]: bannerLaunch,
  };

  return images[pathname] || banner;
};

export const bannerMobileBackground = (pathname: string) => {
  const images: { [key: string]: string } = {
    [MirrorPageEnums.TAXI]: 'banner__mobile__taxi',
    [MirrorPageEnums.LAUNCH]: 'banner__mobile__launch',
  };

  return images[pathname] || '';
};
